import script from "./customerInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./customerInfo.vue?vue&type=script&setup=true&lang=js"

import "./customerInfo.vue?vue&type=style&index=0&id=1c3627f3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c3627f3"]])

export default __exports__